import { ValidationErrors } from '@angular/forms';

import { ControlValidator } from '../models/control-validator.model';

export class DatepickerValidator extends ControlValidator {
  static readonly errorKey = 'bsDatepicker';

  static invalidDateErrorMessage(invalidData: boolean): ValidationErrors | null {
    return invalidData ? DatepickerValidator.validationErrors(this.errorKey, 'Invalid date') : null;
  }
  static forwardedErrorMessage(isInvalid: boolean): ValidationErrors | null {
    return isInvalid ? DatepickerValidator.validationErrors(this.errorKey, 'Forwarded from parent control') : null;
  }
}
